import { useTypedLazyQuery } from '../lib/generated/zeus/apollo';
import { genericScalars } from '../lib/graphql/helpers';
import { sendEmailResponseSelector } from './selectors/send-email-response';
import type { Attachment } from '../../src/components/Feedback';
import type { ApolloError } from '@apollo/client';

export const sendUserFeedbackName = 'sendUserFeedback';

/**
 * Send user feedback to Pras admin.
 * @param userName
 * @param userEmail
 * @param feedback
 * @returns send email response.
 */
export const useLazySendUserFeedback = (
  userName: string,
  userEmail: string,
  feedback: string,
  feedbackReason: string,
  attachments: readonly Attachment[],
  onError: (e: ApolloError) => void
) => {
  return useTypedLazyQuery(
    {
      sendUserFeedback: [
        {
          userName,
          userEmail,
          feedback,
          feedbackReason,
          attachments: [...attachments],
        },
        sendEmailResponseSelector,
      ],
    },
    {
      apolloOptions: {
        onError,
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'network-only',
        initialFetchPolicy: 'network-only',
      },
      scalars: genericScalars,
      operationOptions: {
        operationName: sendUserFeedbackName,
      },
    }
  );
};
